import { useEffect, useState } from 'react';
import { Cropper } from 'react-mobile-cropper';
import 'react-mobile-cropper/dist/style.css';
import { ICONS } from '../../common/icons/icons';
import Screen from '../../components/layout/Screen';
import { useScan } from '../../common/context/ScanProvider';
import Tesseract from 'tesseract.js';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { useGlobal } from '../../common/context/GlobalProvider';
import { Button } from '@/components/ui/button';

const ImageCropperScreen = () => {
  const { originalImage, setScannedText } = useScan();
  const [croppedImage, setCroppedImage] = useState<any>(null);
  const { setIsLoading } = useGlobal();
  const navigate = useNavigate();

  const onChange = (cropper: any) => {
    console.log('Image cropped', cropper);

    let blobURL = cropper.getCanvas()?.toDataURL();

    convertBlobToFile(blobURL);
  };

  const convertBlobToFile = (blobURL: any) => {
    fetch(blobURL)
      .then((response) => response.blob())
      .then((blobData) => {
        const fileName = 'your_desired_filename.ext'; // Specify the desired file name
        const file = new File([blobData], fileName, { type: blobData.type });

        setCroppedImage(file);
      })
      .catch((error) => {
        console.error('Error fetching blob data:', error);
      });
  };

  const recognizeText = async () => {
    if (croppedImage) {
      setIsLoading(true);
      const result = await Tesseract.recognize(croppedImage, 'srp_latn');
      setScannedText(result.data.text);
      setIsLoading(false);
      navigate('/quotes/add');

      console.log(result.data.text);
    }
  };

  useEffect(() => {
    convertBlobToFile(originalImage);
  }, [originalImage]);

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Adjust photo',
          backBtnLabel: 'Choose',
          backBtnUrl: '/choose-photo',
          titleClassName: 'text-white',
        },
        tabNavigator: {
          hide: true,
        },
      }}
    >
      <main className='w-full h-full'>
        <div className='grid grid-rows-8 h-full'>
          <section className='row-span-7 flex items-end justify-center bg-red-500'>
            <section className='w-full h-full'>
              <Cropper
                src={originalImage}
                onInteractionEnd={onChange}
                className={'cropper h-full max-w-[100vw] bg-blue-400'}
              />
            </section>
          </section>
          <div className='p-4 pb-6 row-span-1'>
            <section className='h-full flex bg-secondary-foreground/20 rounded-lg'>
              <Link to='/choose-photo' className='text-secondary flex-1 flex items-center justify-center'>
                {ICONS.addPhoto} <span className='ml-1'>Photos</span>
              </Link>
              <Button className='flex-1 h-full w-full' onClick={recognizeText}>
                {ICONS.scan} <span className='ml-1'>Scan</span>
              </Button>
            </section>
          </div>
        </div>
      </main>
    </Screen>
  );
};

export default ImageCropperScreen;
